/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TOperationListParams } from 'services/operations/operationsTypes';
import type { TRootState } from './store';

const INITIAL_STATE: TOperationListParams & { searchStrPendingValue: string } = {
  page: '1',
  perPage: '20',
  status: '',
  submissionStatus: '',
  searchStrPendingValue: '',
  q: '',
};

const operationsParamsSlice = createSlice({
  name: 'operations',
  initialState: INITIAL_STATE,
  reducers: {
    setTableParams: (
      state,
      {
        payload: { page, perPage, sort, order },
      }: PayloadAction<{ page?: string; perPage?: string; sort?: string; order?: string }>,
    ) => {
      const isSortChanged = sort !== state.sort || order !== state.order;
      state.page = isSortChanged ? '1' : page;
      state.perPage = perPage;
      state.sort = sort;
      state.order = order;
      state.q = state.searchStrPendingValue;
    },
    setStatus: (state, { payload }: PayloadAction<string>) => {
      state.searchStrPendingValue = '';
      state.q = '';
      state.page = '1';
      state.status = payload;
      state.submissionStatus = payload === '' || payload === 'draft' ? payload : 'submitted';
      state.sort = undefined;
      state.order = undefined;
    },
    setSearchStrPendingValue: (state, { payload }: PayloadAction<string>) => {
      state.searchStrPendingValue = payload;
    },
    setSearchStr: (state, { payload }: PayloadAction<string>) => {
      state.page = '1';
      state.searchStrPendingValue = payload;
      state.q = payload;
    },
    setTabKey: (state, { payload: { tabKey } }: PayloadAction<{ tabKey: string }>) => {
      state.searchStrPendingValue = '';
      state.q = '';
      state.q = '';
      state.page = '1';
      state.tabKey = tabKey;
    },
    setInitialParams: (state, { payload }: PayloadAction<TOperationListParams>) => {
      if (payload.page) state.page = payload.page;
      if (payload.perPage) state.perPage = payload.perPage;
      if (payload.status) {
        state.status = payload.status;
        state.submissionStatus = payload.status === '' || payload.status === 'draft' ? payload.status : 'submitted';
      }
      if (payload.q) {
        state.searchStrPendingValue = payload.q;
        state.q = payload.q;
      }
      if (payload.tabKey) state.tabKey = payload.tabKey;
      if (payload.sort) state.sort = payload.sort;
      if (payload.order) state.order = payload.order;
    },
  },
});

export const { setTableParams, setStatus, setSearchStrPendingValue, setSearchStr, setTabKey, setInitialParams } =
  operationsParamsSlice.actions;

export const selectOperationsParamsNet = (state: TRootState) => {
  const { searchStrPendingValue, ...rest } = state.operationsParams;
  return rest;
};

export default operationsParamsSlice.reducer;
